const root = 'PublicInfoForm'
const logo = `${root}-logo`

export const TestId = {
  root,
  cardHeader: `${root}-cardHeader`,
  storeName: `${root}-storeName`,
  establishedDateInput: `${root}-establishedDateInput`,
  description: `${root}-description`,
  logo,
  logoFileInput: `${logo}-fileInput`,
  logoImage: `${logo}-image`,
  logoUploadButton: `${logo}-uploadButton`,
  logoDeleteButton: `${logo}-deleteButton`,
  submitButton: `${root}-submitButton`,
  discardButton: `${root}-discardButton`,
}
